const a = [
  "spacing-025",
  "spacing-050",
  "spacing-075",
  "spacing-100",
  "spacing-125",
  "spacing-150",
  "spacing-200",
  "spacing-250",
  "spacing-300",
  "spacing-400",
  "spacing-500",
  "spacing-600",
  "spacing-700",
  "spacing-800"
];
export {
  a as default
};
//# sourceMappingURL=design-system.es153.js.map
